(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farquhar-artists-apy"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('.ar-page').forEach(root=>{const input=root.querySelector('[data-ar-search]');const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();function filter(){const words=norm(input.value).trim().split(/\s+/);let count=0;root.querySelectorAll('[data-ar-card]').forEach(card=>{const matches=words.every(w=>norm(card.dataset.artist).includes(w));card.hidden=!matches;if(matches)count++;});root.querySelector('[data-ar-count]').textContent=count+' artists';root.querySelector('[data-ar-empty]').hidden=count>0;}input.addEventListener('input',filter);root.querySelector('[data-ar-clear]').addEventListener('click',()=>{input.value='';filter();input.focus();});filter();});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farquhar-artists-nt"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('.ar-page').forEach(root=>{const input=root.querySelector('[data-ar-search]');const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();function filter(){const words=norm(input.value).trim().split(/\s+/);let count=0;root.querySelectorAll('[data-ar-card]').forEach(card=>{const matches=words.every(w=>norm(card.dataset.artist).includes(w));card.hidden=!matches;if(matches)count++;});root.querySelector('[data-ar-count]').textContent=count+' artists';root.querySelector('[data-ar-empty]').hidden=count>0;}input.addEventListener('input',filter);root.querySelector('[data-ar-clear]').addEventListener('click',()=>{input.value='';filter();input.focus();});filter();});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farquhar-artists"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('.ar-page').forEach(root=>{const input=root.querySelector('[data-ar-search]');const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();function filter(){const words=norm(input.value).trim().split(/\s+/);let count=0;root.querySelectorAll('[data-ar-card]').forEach(card=>{const matches=words.every(w=>norm(card.dataset.artist).includes(w));card.hidden=!matches;if(matches)count++;});root.querySelector('[data-ar-count]').textContent=count+' artists';root.querySelector('[data-ar-empty]').hidden=count>0;}input.addEventListener('input',filter);root.querySelector('[data-ar-clear]').addEventListener('click',()=>{input.value='';filter();input.focus();});filter();});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farquhar-collection"]) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-fq-grid]');
    const search = root.querySelector('[data-fq-search]');
    const count = root.querySelector('[data-fq-count]');
    const loading = root.querySelector('[data-fq-loading]');
    const sort = root.querySelector('[data-fq-sort]');
    const dimensionFields = [...root.querySelectorAll('[data-fq-dimension]')];
    const sizePanel = root.querySelector('[data-fq-size-panel]');
    const sizeError = root.querySelector('[data-fq-size-error]');
    const sizeCaption = root.querySelector('[data-fq-size-caption]');
    const sizeParams = new URL(location.href).searchParams;
    dimensionFields.forEach(field => { const value=sizeParams.get('painting_'+field.dataset.fqDimension); if(value && /^\d+(?:\.\d+)?$/.test(value)) field.value=value; });
    function sizeBounds() {
      const values={};
      dimensionFields.forEach(field => {const n=Number(field.value);values[field.dataset.fqDimension]=field.value!=='' && Number.isFinite(n) && n>=0?n:null;});
      ['min','max'].forEach(prefix=>{const a=values[prefix+'_long'],b=values[prefix+'_short'];if(a!=null&&b!=null){values[prefix+'_long']=Math.max(a,b);values[prefix+'_short']=Math.min(a,b);}});
      return values;
    }
    const hasSize = () => dimensionFields.some(field=>field.value!=='' || field.validity.badInput);
    function sizeProblem() {
      if(dimensionFields.some(field=>!field.validity.valid)) return 'Enter a valid measurement of zero or more.';
      const v=sizeBounds();
      if(['long','short'].some(side=>v['min_'+side]!=null&&v['max_'+side]!=null&&v['min_'+side]>v['max_'+side])) return 'The minimum must not exceed the maximum.';
      return '';
    }
    function matchesSize(item) {
      if(!hasSize()) return true;
      const pattern=/(\d+(?:\.\d+)?)\s*(?:cm)?\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:cm)?/i;
      const pair=String(item.dimensions||'').match(pattern)||String(item.title||'').match(pattern);
      if(!pair) return false;
      const longer=Math.max(Number(pair[1]),Number(pair[2])),shorter=Math.min(Number(pair[1]),Number(pair[2])),v=sizeBounds();
      return (v.min_long==null||longer>=v.min_long)&&(v.min_short==null||shorter>=v.min_short)&&(v.max_long==null||longer<=v.max_long)&&(v.max_short==null||shorter<=v.max_short);
    }
    function clearSize(){dimensionFields.forEach(field=>field.value='');}
    function refreshSizeUI(){if(!sizePanel)return;const message=sizeProblem();sizeError.textContent=message;sizeError.hidden=!message;sizeCaption.textContent=hasSize()?'Custom':'Any size';}
    refreshSizeUI();
    root.querySelector('[data-fq-size-clear]')?.addEventListener('click',()=>{clearSize();applyFilters();});
    root.querySelector('[data-fq-size-apply]')?.addEventListener('click',()=>{applyFilters();if(sizeProblem())return;sizePanel.open=false;sizePanel.querySelector('summary').focus();});
    document.addEventListener('click',event=>{if(sizePanel&&!event.target.closest('.fq-custom-size'))sizePanel.open=false;});
    sizePanel?.addEventListener('keydown',event=>{if(event.key==='Escape'){sizePanel.open=false;sizePanel.querySelector('summary').focus();}});
    const budgetControl = root.querySelector('[data-fq-max]');
    const minimumControl = root.querySelector('[data-fq-min]');
    const budget = budgetControl || {value:''};
    const lowerBudget = minimumControl || {value:''};
    const pricePanel = root.querySelector('[data-fq-price-panel]');
    const priceError = root.querySelector('[data-fq-price-error]');
    const priceCaption = root.querySelector('[data-fq-price-caption]');
    const parsePrice = value => { const raw=value.trim().replace(/,/g,''); return raw && /^\d+(?:\.\d{0,2})?$/.test(raw) ? Math.round(Number(raw)*100) : null; };
    const priceParams=new URL(location.href).searchParams;
    if(budgetControl && parsePrice(priceParams.get('painting_max')||'')!==null) budget.value=priceParams.get('painting_max');
    if(minimumControl && parsePrice(priceParams.get('painting_min')||'')!==null) lowerBudget.value=priceParams.get('painting_min');
    let appliedMin=parsePrice(lowerBudget.value), appliedMax=parsePrice(budget.value);
    const minimum=()=>appliedMin;
    const maximum=()=>appliedMax;
    function priceProblem(){
      if([lowerBudget,budget].some(field=>field.value.trim()!==''&&(parsePrice(field.value)===null||!Number.isFinite(parsePrice(field.value))))) return 'Enter a valid price of zero or more.';
      const min=parsePrice(lowerBudget.value),max=parsePrice(budget.value);
      return min!==null&&max!==null&&min>max?'The minimum must not exceed the maximum.':'';
    }
    function refreshPriceUI(){if(priceCaption)priceCaption.textContent=minimum()!==null||maximum()!==null?'Custom':'Any price';}
    function clearPrice(){budget.value='';lowerBudget.value='';appliedMin=null;appliedMax=null;if(priceError){priceError.hidden=true;priceError.textContent='';}refreshPriceUI();}
    function commitPrice(){const message=priceProblem();priceError.textContent=message;priceError.hidden=!message;if(message)return;appliedMin=parsePrice(lowerBudget.value);appliedMax=parsePrice(budget.value);refreshPriceUI();applyFilters();pricePanel.open=false;pricePanel.querySelector('summary').focus();}
    refreshPriceUI();
    root.querySelector('[data-fq-price-apply]')?.addEventListener('click',commitPrice);
    root.querySelector('[data-fq-price-clear]')?.addEventListener('click',()=>{clearPrice();applyFilters();});
    pricePanel?.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('input')){event.preventDefault();commitPrice();}if(event.key==='Escape'){pricePanel.open=false;pricePanel.querySelector('summary').focus();}});
    document.addEventListener('click',event=>{if(pricePanel&&!event.target.closest('.fq-custom-price'))pricePanel.open=false;});
    const emptyActions = document.createElement('div');
    emptyActions.className='fq-empty-actions'; emptyActions.hidden=true;
    emptyActions.style.cssText='display:flex;gap:18px;flex-wrap:wrap;margin:12px 0 24px';
    const clearFilters=document.createElement('button');clearFilters.type='button';clearFilters.textContent='Clear size and price filters';
    clearFilters.style.cssText='background:transparent;border:0;padding:8px 0;text-decoration:underline;color:inherit;font:inherit;cursor:pointer';
    const browseAll=document.createElement('a');browseAll.href='/collections/australian-aboriginal-paintings';browseAll.textContent='Browse all paintings';browseAll.style.cssText='padding:8px 0;text-decoration:underline';
    emptyActions.append(clearFilters,browseAll);loading.after(emptyActions);
    function hideEmpty(){emptyActions.hidden=true;emptyActions.style.display='none';}
    hideEmpty();
    clearFilters.addEventListener('click',()=>{clearSize();clearPrice();applyFilters();});
    const total = count.textContent;
    const originalNext = root.querySelector('[data-fq-next]');
    const more = originalNext || document.createElement('a');
    if (!originalNext) {
      more.className = 'fq-more';
      more.textContent = 'Load more paintings';
      more.href = '#paintings';
      loading.before(more);
    }
    let browseNext = originalNext ? originalNext.href : null;
    const browseCards = [...grid.children];
    let browseBusy = false, browseFailed = false, indexPromise, index;
    let matches = [], shown = 0, version = 0, timer;
    const normalise = value => String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

    function searchWords(value) {
      const aliases = {corinne:'corrina',corinna:'corrina',corrine:'corrina',julianne:'julieanne',justina:'justinna'};
      return String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean).map(word => aliases[word] || word);
    }
    function nearWord(a, b) {
      if (a === b || b.startsWith(a)) return true;
      if (a.length < 4 || b.length < 4 || a[0] !== b[0]) return false;
      const limit = a.length >= 8 && b.length >= 8 ? 2 : 1;
      if (Math.abs(a.length - b.length) > limit) return false;
      const rows = Array.from({length:a.length + 1}, (_,i) => [i]);
      for (let j=0;j<=b.length;j++) rows[0][j]=j;
      for(let i=1;i<=a.length;i++) for(let j=1;j<=b.length;j++) {
        rows[i][j]=Math.min(rows[i-1][j]+1,rows[i][j-1]+1,rows[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
        if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1]) rows[i][j]=Math.min(rows[i][j],rows[i-2][j-2]+1);
      }
      return rows[a.length][b.length] <= limit;
    }
    function searchMatch(text, query, fuzzy) {
      const words=searchWords(text);
      return searchWords(query).every(term => words.some(word => word.startsWith(term) || (fuzzy && nearWord(term,word))));
    }
    const query = () => normalise(search.value).trim();
    const filtering = () => Boolean(query() || hasSize() || minimum() !== null || maximum() !== null);

    // Store only navigation state, never customer data or cached product prices.
    let restoring = false, restoreCancelled = false, browsePages = 1;
    const stateKey = 'fq-browse-v1:' + (history.state?.fqBrowseId || (Date.now().toString(36) + Math.random().toString(36).slice(2)));
    try { history.replaceState({...history.state, fqBrowseId: stateKey.slice(13)}, '', location.href); } catch (_) {}
    const context = () => location.pathname + '?' + new URLSearchParams([...new URL(location.href).searchParams].filter(([key]) => !['preview_theme_id','_fd','pb'].includes(key)).sort()).toString();
    function updateSearchURL() {
      const url = new URL(location.href);
      const value = search.value.trim();
      if (value) url.searchParams.set('painting_search', value);
      else url.searchParams.delete('painting_search');
      if(sizePanel){url.searchParams.delete('painting_size');dimensionFields.forEach(field=>{const key='painting_'+field.dataset.fqDimension;if(field.value!==''&&field.validity.valid)url.searchParams.set(key,field.value);else url.searchParams.delete(key);});}
      if (minimum() !== null) url.searchParams.set('painting_min', String(minimum() / 100));
      else url.searchParams.delete('painting_min');
      if (maximum() !== null) url.searchParams.set('painting_max', String(maximum() / 100));
      else url.searchParams.delete('painting_max');
      try { history.replaceState(history.state, '', url); } catch (_) {}
    }
    function rememberPosition() {
      if (restoring) return;
      const cards = [...grid.querySelectorAll('[data-fq-card]')].filter(card => !card.hidden);
      const anchorIndex = cards.findIndex(card => card.getBoundingClientRect().bottom > 110);
      const anchor = cards[anchorIndex];
      const link = anchor?.querySelector('a[href]');
      try {
        sessionStorage.setItem(stateKey, JSON.stringify({context:context(), time:Date.now(), pages:browsePages,
          shown, search:search.value, y:window.scrollY, anchor:link?.getAttribute('href'), anchorIndex,
          offset:anchor?.getBoundingClientRect().top || 0}));
      } catch (_) {}
    }
    let previousView;
    try {
      const candidate = JSON.parse(sessionStorage.getItem(stateKey) || 'null');
      if (candidate && candidate.context === context() && Date.now() - candidate.time < 86400000) previousView = candidate;
    } catch (_) {}
    root.addEventListener('click', event => {
      if (event.target.closest('[data-fq-card] a[href]')) rememberPosition();
    }, true);
    window.addEventListener('pagehide', rememberPosition);
    function cancelRestoration() { if (restoring) restoreCancelled = true; }
    window.addEventListener('wheel', cancelRestoration, {passive:true});
    window.addEventListener('touchstart', cancelRestoration, {passive:true});
    window.addEventListener('keydown', event => {
      if (['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key)) cancelRestoration();
    });
    async function restorePosition(view) {
      restoring = true;
      root.setAttribute('aria-busy', 'true');
      const previousScrollMode = history.scrollRestoration;
      history.scrollRestoration = 'manual';
      try {
        search.value = view.search || '';
        if (filtering()) {
          const token = ++version;
          await find(token);
          while (!restoreCancelled && token === version && shown < Math.min(view.shown || 24, matches.length)) showMatches(false);
        } else {
          const targetPages = Math.max(1, Math.min(500, Number(view.pages) || 1));
          while (!restoreCancelled && browseNext && !browseFailed && browsePages < targetPages) await loadBrowse();
        }
        if (restoreCancelled) return;
        await document.fonts?.ready;
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if (restoreCancelled) return;
        const cards = [...grid.querySelectorAll('[data-fq-card]')].filter(card => !card.hidden);
        const anchor = cards.find(card => card.querySelector('a[href]')?.getAttribute('href') === view.anchor)
          || cards[Math.min(Math.max(0, view.anchorIndex || 0), cards.length - 1)];
        const y = anchor ? window.scrollY + anchor.getBoundingClientRect().top - view.offset : view.y;
        window.scrollTo({top:Math.max(0, y || 0), behavior:'instant'});
      } finally {
        restoring = false;
        root.removeAttribute('aria-busy');
        history.scrollRestoration = previousScrollMode;
      }
    }
    function refreshWishlist() {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }
    function makeCard(item) {
      const card = document.createElement('article');
      card.className = 'pg-card';
      card.dataset.fqCard = '';
      card.dataset.search = item.title + ' ' + (item.vendor || '') + ' ' + (item.dimensions || '') + ' ' + (item.skus || '');
      const imageBox = document.createElement('div');
      imageBox.className = 'pg-image';
      const link = document.createElement('a');
      link.href = item.url;
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.alt || item.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.sizes = '(max-width: 600px) 45vw, 31vw';
        image.srcset = [300, 500, 700, 900].map(width => {
          const url = new URL(item.image, location.origin);
          url.searchParams.set('width', width);
          return url.href + ' ' + width + 'w';
        }).join(', ');
        link.append(image);
      }
      const heart = document.createElement('button');
      heart.type = 'button';
      heart.className = 'fq-card-heart swym-button swym-add-to-wishlist-view-product product_' + item.id;
      Object.assign(heart.dataset, {withEpi:'true', swaction:'addToWishlist', productId:String(item.id), variantId:String(item.variant), productUrl:new URL(item.url, location.origin).href});
      heart.setAttribute('aria-label', 'Save ' + item.title + ' to wishlist');
      heart.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
      imageBox.append(link, heart);
      const title = document.createElement('h3');
      title.className = 'pg-title';
      const titleLink = document.createElement('a');
      titleLink.href = item.url;
      titleLink.textContent = item.title;
      title.append(titleLink);
      card.append(imageBox, title);
      if (item.dimensions) {
        const dimensions = document.createElement('p');
        dimensions.className = 'pg-size';
        dimensions.textContent = item.dimensions;
        card.append(dimensions);
      }
      const price = document.createElement('p');
      price.className = 'pg-price';
      const decoded = document.createElement('textarea');
      decoded.innerHTML = item.price;
      price.textContent = decoded.value;
      card.append(price);
      return card;
    }
    async function readIndexPage(page) {
      const url = new URL(location.href);
      url.searchParams.set('view', 'farquhar-search');
      url.searchParams.set('page', page);
      url.searchParams.delete('painting_search');
      const response = await fetch(url, {signal:AbortSignal.timeout(20000)});
      if (!response.ok) throw Error('Index unavailable');
      const data = await response.json();
      if (!Array.isArray(data.products) || !Number.isInteger(data.pages)) throw Error('Invalid index');
      return data;
    }
    function getIndex() {
      if (index) return Promise.resolve(index);
      if (indexPromise) return indexPromise;
      indexPromise = (async () => {
        const first = await readIndexPage(1);
        const pages = [first.products];
        for (let page = 2; page <= first.pages; page += 3) {
          const batch = await Promise.all(Array.from({length:Math.min(3, first.pages - page + 1)}, (_, offset) => readIndexPage(page + offset)));
          pages.push(...batch.map(result => result.products));
        }
        index = pages.flat().filter(item => !/\b(?:chernee|brooke)\s+sutton\b/i.test((item.title + " " + (item.vendor || "")).replace(/['’]/g, ""))).map(item => ({...item, search:normalise(item.title + ' ' + (item.vendor || '') + ' ' + (item.dimensions || '') + ' ' + (item.skus || ''))}));
        return index;
      })().catch(error => { indexPromise = null; throw error; });
      return indexPromise;
    }
    function showMatches(reset) {
      if (reset) { shown = 0; grid.replaceChildren(); }
      const batch = matches.slice(shown, shown + 24);
      grid.append(...batch.map(makeCard));
      shown += batch.length;
      count.textContent = matches.length + ' matching paintings';
      more.hidden = shown >= matches.length;
      more.href = '#paintings';
      more.textContent = 'Load more paintings';
      refreshWishlist();
    }
    async function find(token) {
      if (!filtering() || sizeProblem()) return;
      loading.textContent = index ? '' : 'Searching this collection…';
      try {
        const items = await getIndex();
        if (token !== version || !filtering()) return;
        hideEmpty();
        const eligible=items.filter(item=>matchesSize(item)&&(minimum()===null||item.canvas_price>=minimum())&&(maximum()===null||item.canvas_price<=maximum()));
        matches=eligible.filter(item=>searchMatch(item.search,query(),false));
        let closeMatches=false;
        if(!matches.length && query()){matches=eligible.filter(item=>searchMatch(item.search,query(),true));closeMatches=matches.length>0;}
        showMatches(true);
        loading.textContent=closeMatches?'Showing close spelling matches for “'+search.value.trim()+'”.':matches.length?'':'No paintings found. Try an artist’s name or a broader search.';
        if(!matches.length){
          const hasFilters=Boolean(hasSize()||minimum()!==null||maximum()!==null);
          if(hasFilters) loading.textContent='No paintings match these filters. Clear size and price filters to keep searching for “'+(search.value.trim()||'all paintings')+'”.';
          clearFilters.hidden=!hasFilters;emptyActions.hidden=false;emptyActions.style.display='flex';
        }
      } catch (error) {
        if (token !== version || !filtering()) return;
        count.textContent = 'Search incomplete';
        loading.textContent = 'Search could not finish. Select Retry search to try again.';
        more.textContent = 'Retry search';
        more.hidden = false;
      }
    }
    function restoreBrowse() {
      hideEmpty();
      browseCards.forEach(card => { card.hidden = false; });
      grid.replaceChildren(...browseCards);
      count.textContent = total;
      loading.textContent = '';
      more.textContent = 'Load more paintings';
      more.hidden = !browseNext;
      if (browseNext) more.href = browseNext;
      refreshWishlist();
    }
    async function loadBrowse() {
      if (filtering() || browseBusy || !browseNext || browseFailed) return;
      browseBusy = true;
      loading.textContent = 'Loading paintings…';
      try {
        const url = new URL(browseNext, location.origin);
        url.searchParams.set('section_id', root.closest('[id^="shopify-section-"]').id.replace('shopify-section-', ''));
        const response = await fetch(url, {signal:AbortSignal.timeout(20000)});
        if (!response.ok) throw Error('Page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-fq-grid]');
        if (!incoming) throw Error('Grid unavailable');
        const cards = [...incoming.children].map(card => document.importNode(card, true));
        browseCards.push(...cards);
        browsePages++;
        browseNext = doc.querySelector('[data-fq-next]')?.getAttribute('href') || null;
        if (!filtering()) {
          grid.append(...cards);
          count.textContent = total;
          loading.textContent = '';
          more.hidden = !browseNext;
          if (browseNext) more.href = browseNext;
          refreshWishlist();
        }
      } catch (error) {
        browseFailed = true;
        if (!filtering()) loading.textContent = 'Could not load more paintings. Select Load more to retry.';
      } finally { browseBusy = false; }
    }
    more.addEventListener('click', event => {
      event.preventDefault();
      if (filtering()) {
        if (index) showMatches(false); else find(version);
      } else { browseFailed = false; loadBrowse(); }
    });
    new IntersectionObserver(entries => {
      if (!restoring && entries.some(entry => entry.isIntersecting) && !more.hidden) {
        if (filtering()) { if (index && shown < matches.length) showMatches(false); }
        else loadBrowse();
      }
    }, {rootMargin:'250px'}).observe(more);
    function applyFilters() {
      hideEmpty();
      refreshSizeUI();
      cancelRestoration();
      updateSearchURL();
      version++;
      clearTimeout(timer);
      more.textContent = 'Load more paintings';
      if(sizeProblem()){matches=[];grid.replaceChildren();more.hidden=true;loading.textContent='Adjust the size range above to see matching paintings.';return;}
      if (!filtering()) { restoreBrowse(); return; }
      const terms = query().split(/\s+/);
      [...grid.children].forEach(card => { card.hidden = !searchMatch(card.dataset.search,query(),true); });
      count.textContent = 'Searching this collection…';
      more.hidden = true;
      loading.textContent = '';
      const token = version;
      timer = setTimeout(() => find(token), 350);
    }
    search.addEventListener('input', applyFilters);
    dimensionFields.forEach(field=>field.addEventListener('input',applyFilters));

    sort.addEventListener('change', () => {
      cancelRestoration();
      rememberPosition();
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      if (search.value.trim()) url.searchParams.set('painting_search', search.value.trim());
      else url.searchParams.delete('painting_search');
      location.assign(url);
    });
    more.hidden = !browseNext;
    const saved = new URL(location.href).searchParams.get('painting_search');
    if (previousView) { restorePosition(previousView); }
    else if (saved || filtering()) { search.value = saved || ''; more.hidden = true; if(sizeProblem())applyFilters();else find(++version); }
  }
  document.querySelectorAll('[data-fq-collection]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fq-collection]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farquhar-collections"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('.cl-page').forEach(root=>{const requested=new URL(location.href).searchParams.get('category');let group=['Discover','Colour','Size','Price'].find(value=>value.toLowerCase()===(requested||'').toLowerCase())||'Discover';root.querySelectorAll('[data-cl-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.clFilter===group)));const sold=root.querySelector('[data-sold="true"]');if(sold)sold.parentElement.append(sold);const input=root.querySelector('[data-cl-search]');function filter(){let total=0;root.querySelectorAll('[data-cl-card]').forEach(card=>{const show=(card.dataset.group===group)&&card.textContent.toLowerCase().includes(input.value.trim().toLowerCase());card.hidden=!show;if(show)total++;});root.querySelector('[data-cl-count]').textContent=total+' collections';root.querySelector('[data-cl-empty]').hidden=total>0;}root.querySelectorAll('[data-cl-filter]').forEach(button=>button.addEventListener('click',()=>{group=button.dataset.clFilter;root.querySelectorAll('[data-cl-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));filter();}));input.addEventListener('input',filter);filter();});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farquhar-header"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const init=root=>root.querySelectorAll('.fq-cart-menu').forEach(menu=>{
  if(menu.dataset.cartReady)return;menu.dataset.cartReady='true';
  const summary=menu.querySelector('summary'),list=menu.querySelector('[data-cart-items]'),status=menu.querySelector('[data-cart-status]'),footer=menu.querySelector('[data-cart-footer]'),total=menu.querySelector('[data-cart-total]');
  let request,version=0;
  const element=(tag,text,className)=>{const node=document.createElement(tag);if(text)node.textContent=text;if(className)node.className=className;return node;};
  const refresh=async()=>{
   const current=++version;request?.abort();request=new AbortController();status.textContent='Loading your cart…';footer.hidden=true;list.replaceChildren();
   try{
    const response=await fetch(menu.dataset.cartRoot+'cart.js',{headers:{Accept:'application/json'},cache:'no-store',signal:request.signal});if(!response.ok)throw Error('Cart unavailable');
    const cart=await response.json();if(current!==version||!menu.open)return;
    if(!Array.isArray(cart.items)||!cart.currency||!Number.isFinite(cart.total_price))throw Error('Invalid cart');
    const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:cart.currency}).format(value/100);
    document.querySelectorAll('[data-fq-cart-count]').forEach(node=>{if(node.textContent!==String(cart.item_count))node.textContent=String(cart.item_count);});
    summary.classList.toggle('has-items',cart.item_count>0);
    for(const item of cart.items){
     const row=element('li',null,'fq-cart-item'),imageLink=element('a'),body=element('div'),title=element('a',item.product_title||item.title);
     const url=new URL(item.url,location.origin);if(url.origin!==location.origin)continue;
     imageLink.href=title.href=url.href;imageLink.setAttribute('aria-label','View '+(item.product_title||item.title));
     if(item.image){const image=element('img');const src=new URL(item.image,location.origin);if(src.protocol==='https:'){src.searchParams.set('width','240');image.src=src.href;image.alt='';image.width=76;image.height=90;imageLink.append(image);}}
     body.append(title);
     if(item.variant_title&&item.variant_title!=='Default Title')body.append(element('p',item.variant_title));
     if(/\bcanvas only\b/i.test(item.variant_title||''))body.append(element('p','Free worldwide shipping','fq-cart-delivery-note'));
     if(item.quantity>1)body.append(element('p','Quantity: '+item.quantity));
     body.append(element('p',money(item.final_line_price),'fq-cart-line-price'));
     const remove=element('button','Remove','fq-cart-remove');remove.type='button';remove.setAttribute('aria-label','Remove '+(item.product_title||item.title)+' from cart');
     remove.addEventListener('click',async()=>{
      if(menu.dataset.cartUpdating)return;menu.dataset.cartUpdating='true';
      list.querySelectorAll('.fq-cart-remove').forEach(button=>button.disabled=true);remove.textContent='Removing…';status.textContent='';
      try{
       const response=await fetch(menu.dataset.cartRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.key,quantity:0})});
       if(!response.ok)throw Error('Unable to remove item');const updated=await response.json();
       if(!Array.isArray(updated.items)||!Number.isFinite(updated.item_count))throw Error('Invalid cart');
       document.querySelectorAll('[data-fq-cart-count]').forEach(node=>node.textContent=String(updated.item_count));summary.classList.toggle('has-items',updated.item_count>0);
       if(menu.open)await refresh();
      }catch(error){status.textContent='Could not remove this painting. Please try again.';remove.textContent='Remove';}
      finally{delete menu.dataset.cartUpdating;list.querySelectorAll('.fq-cart-remove').forEach(button=>button.disabled=false);}
     });body.append(remove);
row.append(imageLink,body);list.append(row);
    }
    total.textContent=money(cart.total_price)+' '+cart.currency;footer.hidden=!cart.item_count;
    status.textContent=cart.item_count?'':'Your cart is empty.';
    if(!cart.item_count){const explore=element('a','Explore the collections');explore.href=menu.dataset.cartRoot+'collections';explore.style.display='block';explore.style.marginTop='10px';explore.style.textDecoration='underline';status.append(explore);}
   }catch(error){if(error.name!=='AbortError'&&current===version){status.textContent='Unable to load your cart. Please use View cart below.';footer.hidden=true;}}
  };
  menu.addEventListener('toggle',()=>{if(menu.open)refresh();else{version++;request?.abort();}});
  menu.querySelector('[data-cart-close]').addEventListener('click',()=>{menu.open=false;summary.focus();});
  document.addEventListener('click',event=>{if(event.target.closest('[data-fq-open-wishlist],[data-fq-wish-open]'))menu.open=false;});
  window.addEventListener('pageshow',()=>{if(menu.open)refresh();});
 });
 init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
})();

(()=>{const init=root=>root.querySelectorAll('.fq-header-cart').forEach(link=>{if(link.dataset.countReady)return;link.dataset.countReady='true';const count=link.querySelector('[data-fq-cart-count]');if(!count)return;const update=()=>link.classList.toggle('has-items',parseInt(count.textContent,10)>0);update();new MutationObserver(update).observe(count,{childList:true,characterData:true,subtree:true});});init(document);document.addEventListener('shopify:section:load',event=>init(event.target));})();

(function(){
  if(window.fqHeaderWishlistBound)return;
  window.fqHeaderWishlistBound=true;
  let wishlistApp=null;
  let pendingLink=null;
  function openWishlist(link){
    document.querySelectorAll('.q-header details[open]').forEach(function(menu){menu.removeAttribute('open');});
    wishlistApp.ui.open();
    link.removeAttribute('aria-busy');
  }
  window.SwymCallbacks=window.SwymCallbacks||[];
  window.SwymCallbacks.push(function(swat){
    wishlistApp=swat;
    if(pendingLink){openWishlist(pendingLink);pendingLink=null;}
  });
  document.addEventListener('click',function(event){
    const link=event.target.closest('[data-fq-open-wishlist]');
    if(!link)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(wishlistApp){openWishlist(link);}
    else{pendingLink=link;link.setAttribute('aria-busy','true');}
  },true);
})();

(() => {
const init = root => root.querySelectorAll('.fq-header-search').forEach(menu => {
 if(menu.dataset.ready) return; menu.dataset.ready='true';
 const input=menu.querySelector('input'), results=menu.querySelector('.fq-search-results'), form=menu.querySelector('form');
 let timer, request, version=0;

    function searchWords(value) {
      const aliases = {corinne:'corrina',corinna:'corrina',corrine:'corrina',julianne:'julieanne',justina:'justinna'};
      return String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean).map(word => aliases[word] || word);
    }
    function nearWord(a, b) {
      if (a === b || b.startsWith(a)) return true;
      if (a.length < 4 || b.length < 4 || a[0] !== b[0]) return false;
      const limit = a.length >= 8 && b.length >= 8 ? 2 : 1;
      if (Math.abs(a.length - b.length) > limit) return false;
      const rows = Array.from({length:a.length + 1}, (_,i) => [i]);
      for (let j=0;j<=b.length;j++) rows[0][j]=j;
      for(let i=1;i<=a.length;i++) for(let j=1;j<=b.length;j++) {
        rows[i][j]=Math.min(rows[i-1][j]+1,rows[i][j-1]+1,rows[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
        if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1]) rows[i][j]=Math.min(rows[i][j],rows[i-2][j-2]+1);
      }
      return rows[a.length][b.length] <= limit;
    }
    function searchMatch(text, query, fuzzy) {
      const words=searchWords(text);
      return searchWords(query).every(term => words.some(word => word.startsWith(term) || (fuzzy && nearWord(term,word))));
    }
 const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
 const addLink=(url,title,image)=>{const a=document.createElement('a');a.href=url;if(image){const img=document.createElement('img');img.src=image;img.alt='';a.append(img);}const span=document.createElement('span');span.textContent=title;a.append(span);results.append(a);return a;};
 const heading=text=>{const h=document.createElement('h3');h.textContent=text;results.append(h);};
 const destination=()=>{
 const query=input.value.trim(), base=form.action.split('/collections/')[0];
 const prints=/\b(?:prints?|reproductions?)\b/i.test(query), gleghorn=/\bgleghorn\b/i.test(query);
 let path='/collections/australian-aboriginal-paintings', filter=query;
 if(gleghorn){path='/collections/thomas-gleghorn';filter=query.replace(/\b(?:thomas|gleghorn)\b/gi,'').trim();}
 else if(prints){path='/collections/aboriginal-canvas-prints';filter=query.replace(/\b(?:canvas|art|aboriginal|indigenous|prints?|reproductions?)\b/gi,'').replace(/\s+/g,' ').trim();}
 return base+path+(filter?'?painting_search='+encodeURIComponent(filter):'');
};
form.addEventListener('submit',event=>{event.preventDefault();if(input.value.trim())window.location.assign(destination());});
const all=()=>{const a=addLink(destination(),'View all results');a.className='fq-search-all';};
 const update=async()=>{
   const q=input.value.trim(), id=++version; request?.abort(); results.replaceChildren(); if(!q)return;
   const artistLinks=[...document.querySelectorAll('.q-artist-links>a')].filter(a=>!/sutton/i.test(a.textContent));
   let artists=artistLinks.filter(a=>searchMatch(a.textContent,q,false));
   if(!artists.length) artists=artistLinks.filter(a=>searchMatch(a.textContent,q,true));
   artists=artists.slice(0,3);
   const vocabulary=[...new Set(artistLinks.flatMap(a=>searchWords(a.textContent)))];
   const corrected=searchWords(q).map(term=>{if(vocabulary.some(word=>word.startsWith(term)))return term;const alternatives=vocabulary.filter(word=>nearWord(term,word));return alternatives.length===1?alternatives[0]:term;}).join(' ');
   if(artists.length){heading('Artists');artists.forEach(a=>addLink(a.href,a.textContent.trim()));}all();
   if(q.length<2)return;
   request=new AbortController();
   try{const params=new URLSearchParams({q:corrected || q,'resources[type]':'product','resources[limit]':'10','resources[options][unavailable_products]':'hide'});
     const base=form.action.split('/collections/')[0];const response=await fetch(base+'/search/suggest.json?'+params,{signal:request.signal});if(!response.ok)return;
     const data=await response.json();if(id!==version)return;
     const products=(data.resources?.results?.products||[]).filter(p=>p.available!==false&&!/sutton/i.test(p.title+' '+p.vendor)).sort((a,b)=>Number(/\bprints?\b|reproduction/i.test(a.title+' '+a.product_type))-Number(/\bprints?\b|reproduction/i.test(b.title+' '+b.product_type))).slice(0,4);
     results.querySelector('.fq-search-all')?.remove();if(products.length){heading('Paintings');products.forEach(p=>addLink(p.url,p.title,typeof p.image==='string'?p.image:p.featured_image?.url));}else if(!artists.length){const note=document.createElement('p');note.textContent='No suggestions yet. Try an artist’s name or a broader search.';results.append(note);}all();
   }catch(error){if(error.name!=='AbortError'&&id===version&&!results.querySelector('.fq-search-all'))all();}
 };
 input.addEventListener('input',()=>{clearTimeout(timer);version++;request?.abort();results.replaceChildren();timer=setTimeout(update,220);});
 menu.addEventListener('toggle',()=>{if(menu.open)input.focus();else{clearTimeout(timer);version++;request?.abort();}});
 menu.querySelector('[data-fq-close-search]').addEventListener('click',()=>{menu.open=false;menu.querySelector('summary').focus();});
});init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

document.addEventListener('toggle', (event) => { if(event.target.matches('.q-dropdown') && event.target.open) document.querySelectorAll('.q-dropdown[open]').forEach(other => {if(other!==event.target) other.open=false;}); }, true);
document.addEventListener('click', event => {document.querySelectorAll('.q-dropdown[open]').forEach(menu => {if(!menu.contains(event.target)) menu.open=false;});});
document.addEventListener('keydown', event => {if(event.key==='Escape'){const menu=document.querySelector('.q-dropdown[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});

(() => {
 const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
 const update = input => {
   const panel = input.closest('.q-panel');
   if (!panel) return;
   const terms = normalise(input.value).split(/\s+/).filter(Boolean);
   const links = [...panel.querySelectorAll('.q-artist-links > a')];
   let count = 0;
   links.forEach(link => { const matches = terms.every(term => normalise(link.textContent).includes(term)); link.hidden = !matches; if (matches) count++; });
   panel.querySelector('[data-q-search-status]').textContent = count + (count === 1 ? ' artist' : ' artists') + (terms.length ? ' found' : ' available');
   panel.querySelector('[data-q-search-clear]').hidden = !input.value;
   let empty = panel.querySelector('.q-search-empty');
   if (!empty) { empty = document.createElement('p'); empty.className = 'q-search-empty'; empty.textContent = 'No matching artists. Try another name or clear the search.'; panel.querySelector('.q-artist-links').after(empty); }
   empty.hidden = count !== 0;
 };
 document.addEventListener('input', event => { if (event.target.matches('[data-q-artist-search]')) update(event.target); });
 document.addEventListener('click', event => { const button = event.target.closest('[data-q-search-clear]'); if (button) { const input = button.closest('.q-panel').querySelector('[data-q-artist-search]'); input.value = ''; update(input); input.focus(); } });
 const init = root => root.querySelectorAll('[data-q-artist-search]').forEach(update);
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farquhar-home"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click',function(event){const button=event.target.closest('[data-painting-direction]');if(!button)return;const track=button.closest('.q-paintings').querySelector('.q-painting-track');const card=track.querySelector('.q-card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:(card.getBoundingClientRect().width+gap)*Number(button.dataset.paintingDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

document.addEventListener('click',event=>{const button=event.target.closest('[data-artist-direction]');if(!button)return;const grid=button.closest('.q-portrait-section').querySelector('.q-portrait-grid');const card=grid.querySelector('.q-portrait-card');if(!card)return;grid.scrollBy({left:(card.getBoundingClientRect().width+(parseFloat(getComputedStyle(grid).gap)||0))*Number(button.dataset.artistDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farquhar-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.matches('[data-print-option]')){const form=event.target.closest('form'),selects=[...form.querySelectorAll('[data-print-option]')],radios=[...form.querySelectorAll('input[name="id"]')],values=selects.map(s=>s.value);let radio=radios.find(r=>JSON.stringify(JSON.parse(r.dataset.printOptions))===JSON.stringify(values));if(!radio){const index=Number(event.target.dataset.printOption);radio=radios.find(r=>!r.disabled&&JSON.parse(r.dataset.printOptions)[index]===event.target.value);}if(radio){const chosen=JSON.parse(radio.dataset.printOptions);selects.forEach((s,i)=>s.value=chosen[i]);radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}return;}const input=event.target;if(!input.matches('[data-product-price-value]'))return;const root=input.closest('[id^="Product-"]');root.querySelector('[data-product-price]').textContent=input.dataset.productPriceValue;const ref=root.querySelector('[data-fq-reference]');if(ref){ref.textContent=input.dataset.productReference||'';ref.hidden=!ref.textContent;root.querySelector('[data-fq-reference-label]').hidden=!ref.textContent;}const buy=root.querySelector('[data-fq-buy]');buy.disabled=input.dataset.productAvailable!=='true';buy.childNodes[0].textContent=buy.disabled?'Sold out':'Buy now';document.dispatchEvent(new CustomEvent('fq:variant-changed'));const delivery=root.querySelector('[data-fq-delivery]');const printSelect=root.querySelector('[data-print-option]');delivery.textContent=input.closest('label').textContent.toLowerCase().includes('adelaide')?'This ready-to-hang option is available for delivery within Adelaide only. Outside Adelaide, choose canvas only.':'For interstate and international delivery, choose canvas only. Shipping is free. Your '+(printSelect?'print':'painting')+' arrives rolled in a protective tube.';const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState(null,'',url);const add=root.querySelector('[data-product-add]');add.disabled=input.dataset.productAvailable!=='true';add.textContent=add.disabled?'Sold out':'Add to cart';});
document.addEventListener('click',event=>{const button=event.target.closest('[data-product-photo]');if(!button)return;const root=button.closest('[id^="Product-"]');const img=root.querySelector('.pd-product-main');img.removeAttribute('srcset');img.src=button.dataset.productPhoto;img.alt=button.dataset.productAlt;root.querySelectorAll('[data-product-photo]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});

(()=>{const fine=matchMedia('(hover:hover) and (pointer:fine)');function reset(frame){frame.classList.remove('pd-hover-zoom');const img=frame.querySelector(':scope > img');if(img)img.style.transformOrigin='50% 50%';}document.addEventListener('pointermove',event=>{const frame=event.target.closest('.pd-main-image');if(!frame)return;if(!fine.matches||event.pointerType!=='mouse'||event.target.closest('button')){reset(frame);return;}const img=frame.querySelector(':scope > img');if(!img)return;const rect=frame.getBoundingClientRect();const x=Math.max(0,Math.min(100,(event.clientX-rect.left)/rect.width*100));const y=Math.max(0,Math.min(100,(event.clientY-rect.top)/rect.height*100));img.style.transformOrigin=x+'% '+y+'%';frame.classList.add('pd-hover-zoom');});document.addEventListener('pointerout',event=>{const frame=event.target.closest('.pd-main-image');if(frame&&(!event.relatedTarget||!frame.contains(event.relatedTarget)))reset(frame);});document.addEventListener('click',event=>{if(event.target.closest('[data-photo],[data-product-photo]'))document.querySelectorAll('.pd-main-image').forEach(reset);});fine.addEventListener('change',()=>document.querySelectorAll('.pd-main-image').forEach(reset));})();


  } catch(e) { console.error(e); }
})();
})();
